import "bootstrap";
import "./modules/aos";
import "./modules/swiper";
import "./modules/tab";
import "./modules/navbar";
import "./modules/calc";
import "./modules/form";
import "./modules/animation";
